module.exports = __webpack_public_path__ + "img/blockquote.c9b618c4.svg";